/* eslint-disable */
/**
 * 录入卡片组件
 * @author xiao.xu 2018.11.20
 */
import React from 'react';
import { Icon } from '@ok/okd';
import { translate } from '_common/utils/language';
import { FormType } from '../FormType';
import LeftTitle from './LeftTitle';
import ItemContext from './ItemContext';

const clauseItemType = 'shareholder-clause-message';

export default class ItemUpload extends ItemContext {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: '',
      dataError: false,
      value: '',
      photoItem: {}, // 单个图片
    };
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
  }

  /**
   * 选择文件变化监听
   * @param e
   */
  onChange = (e) => {
    const chosenFile = e.target.files[0];
    let imgType = e.target.getAttribute('data-type');
    imgType = parseInt(imgType, 10);
    const { key, onChange, formType, extend } = this.props.dataSource;
    const allow = true;
    if (onChange) {
      const ret = onChange(key, formType, imgType, chosenFile, allow, extend);
      // if return a Promise
      if (ret && ret.then) {
        this.setState({ loading: true });
        ret.then(
          () => {
            this.setState({ loading: false });
          },
          () => {
            this.setState({ loading: false });
          }
        );
      }
    }
  };

  /**
   * 删除
   */
  onDelete = (item, index) => {
    const type = item.type;
    const { key, onDelete, formType, extend } = this.props.dataSource;
    onDelete && onDelete(key, formType, type, extend, item, index);
  };

  onModify = (item, index) => {
    const type = item.type;
    const { key, onModify, formType, extend } = this.props.dataSource;
    onModify && onModify(key, formType, type, extend, item, index);
  };

  onAdd = (item) => {
    const type = item.type;
    const { key, onAdd, formType, extend } = this.props.dataSource;
    onAdd && onAdd(key, formType, type, extend, item);
  };

  // 渲染卡片
  renderCard() {
    const { inputList } = this.props.dataSource;
    let uploadIndex = -1;
    return (
      <React.Fragment>
        {inputList &&
          inputList.map((item, index) => {
            const { id, cardTitle } = item;
            let comp = null;
            if (id) {
              const {
                primaryText,
                lesserText,
                messageList,
                shareInfoList,
                icon,
              } = item.inputAttr;
              comp = (
                <React.Fragment key={index}>
                  <br />
                  <div className="card-item" key={index}>
                    <div className="title-box">
                      <Icon
                        className={icon || 'okj-account-verification-level1'}
                      />
                      <span className="card-item-title">{cardTitle}</span>
                      <span className="icon-box">
                        {typeof this?.props?.dataSource?.onDelete ===
                          'function' && (
                          <span
                            className="operation"
                            onClick={() => {
                              this.onDelete(item, index);
                            }}
                          >
                            <Icon className="okj-account-eliminate icon" />
                          </span>
                        )}
                        {typeof this?.props?.dataSource?.onModify ===
                          'function' && (
                          <span
                            className="operation"
                            onClick={() => {
                              this.onModify(item, index);
                            }}
                          >
                            <Icon className="okds-edit icon" />
                          </span>
                        )}
                      </span>
                    </div>
                    <div className="card-item-text-box">
                      <div className="shareholder-text-holder">
                        <span className="primary-text">{primaryText}</span>
                        <span className="lesser-text">{lesserText}</span>
                        {messageList &&
                          messageList.map((messageItem, index) => {
                            const { text, type } = messageItem;
                            return (
                              <span className={`message ${type}`} key={index}>
                                {text}
                              </span>
                            );
                          })}
                      </div>
                      {shareInfoList &&
                        shareInfoList.map((infoItem, index) => {
                          const { text, type } = infoItem;
                          if (type == clauseItemType) {
                            const clauseItemList = text.split(',');
                            const returnItem = clauseItemList.map(
                              (clauseItem, i) => {
                                return (
                                  <div className={`shareInfo ${type}`} key={i}>
                                    {clauseItem}
                                  </div>
                                );
                              }
                            );
                            return (
                              <React.Fragment key={index}>
                                {returnItem}
                              </React.Fragment>
                            );
                          }
                          return (
                            <React.Fragment key={index}>
                              <div
                                className={`shareInfo ${type}`}
                                key={text + type}
                              >
                                {text}
                              </div>
                            </React.Fragment>
                          );
                        })}
                    </div>
                  </div>
                </React.Fragment>
              );
            } else if (uploadIndex < 0) {
              uploadIndex = index;
            }
            return comp;
          })}
        {uploadIndex >= 0 && (
          <React.Fragment>
            <br />
            <div className="add-card-item" onClick={this.onAdd}>
              <div className="add-box">
                <Icon className="add-icon okds-plus-circle-filled" />
                <div className="add-text">{translate('jp.company.add')}</div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }

  render() {
    const { dataError, errorMsg } = this.state;
    const { bottomArea } = this.props.dataSource;
    return (
      <div
        className="form-item"
        data-error={dataError && errorMsg && errorMsg.length !== 0}
      >
        <LeftTitle dataSource={this.props.dataSource} />
        <div className="form-card-box">
          {this.renderCard()}
          {bottomArea}
          <span className="form-error-tips">{errorMsg}</span>
        </div>
      </div>
    );
  }
}
ItemUpload.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    formType: FormType.CARD,
    inputAttr: {},
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
